import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  const navigate = useNavigate();

  const goQuote = () => {
    navigate("/quote");
    window.scrollTo(0, 0);
  };
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[#0A0C10]">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8 sm:pt-20">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="inline-block rounded-lg bg-white p-4">
              <img
                src="/ap_logo_wide.png"
                alt="AP Pumping — We Pump Blow and Go"
                data-testid="footer-logo"
                className="w-64 sm:w-80"
              />
            </div>
            <p className="mt-4 font-tech text-xs uppercase tracking-[0.3em] text-slate-500">
              We pump, blow and go
            </p>
          </div>
          <div className="flex flex-col gap-3 md:items-end">
            <a
              href="tel:0450454453"
              data-testid="footer-call-button"
              className="inline-flex items-center gap-3 bg-[#0052FF] px-7 py-4 font-display text-xl font-bold uppercase tracking-wider text-white transition-all duration-300 hover:bg-[#2E74FF] hover:shadow-[0_0_36px_rgba(0,82,255,0.6)]"
            >
              <Phone className="h-5 w-5" />
              Andrew — 0450 454 453
            </a>
            <a
              href="tel:0474422539"
              data-testid="footer-call-eli-button"
              className="inline-flex items-center gap-3 border border-[#0052FF]/60 px-7 py-3 font-display text-lg font-bold uppercase tracking-wider text-white transition-all duration-300 hover:bg-[#0052FF] hover:shadow-[0_0_36px_rgba(0,82,255,0.6)]"
            >
              <Phone className="h-4 w-4" />
              Eli — 0474 422 539
            </a>
            <a
              href="mailto:APpumping@hotmail.com"
              data-testid="footer-email-link"
              className="inline-flex items-center gap-3 font-tech text-xs uppercase tracking-[0.25em] text-slate-300 transition-colors hover:text-[#4D8DFF]"
            >
              <Mail className="h-4 w-4 text-[#0052FF]" />
              APpumping@hotmail.com
            </a>
            <span
              data-testid="footer-service-area"
              className="inline-flex items-center gap-3 font-tech text-xs uppercase tracking-[0.25em] text-slate-300"
            >
              <MapPin className="h-4 w-4 text-[#0052FF]" />
              Servicing all areas
            </span>
            <span
              data-testid="footer-socials"
              className="inline-flex items-center gap-3 font-tech text-xs uppercase tracking-[0.25em] text-slate-300"
            >
              <Facebook className="h-4 w-4 text-[#0052FF]" />
              Follow us — Facebook / Socials
            </span>
            <button
              onClick={goQuote}
              data-testid="footer-quote-link"
              className="mt-2 self-start font-tech text-xs uppercase tracking-[0.25em] text-slate-400 transition-colors hover:text-[#4D8DFF] md:self-end"
            >
              Get a quick quote
            </button>
          </div>
        </div>

        <div className="mt-14 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 font-tech text-[11px] uppercase tracking-[0.2em] text-slate-600 sm:flex-row">
          <span>© {year} AP Pumping — All rights reserved</span>
          <span data-testid="footer-tagline">When needed, we'll be there</span>
        </div>
      </div>
    </footer>
  );
}